import $ from "jquery";

/**
 * We intialise major animations here to control the play globally
 * Some animations are defined within the code
 */


/**
 * Navigation Logic
 */
export default class Navigation {

    constructor(controller, viewport) {


        this.viewport = viewport;
        this.controller = controller;

                // Change animation on resize
        this.viewport.on('viewport.resize', this.onWindowResize);

        // Events
        this._initEvents();


    }


    // PUBLIC
    onWindowResize() {

    }


    toggleMainNav() {
        let me = this;


    }

    hideMainNav() {

    }

    showMainNav() {

    }


    /**
     * Set up event listeners.
     * Since we are not fully ajax, there is no de-register of events ( ! )
     * @private
     */
    _initEvents() {
    }


}
